import React, { useEffect, useState } from "react";
import PubSub from 'pubsub-js';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'antd';

import { IDataTableColumn } from "../../../types/DataTable.types";
import { ToolBoxSearch } from "../../Common/DataTableToolBox/ToolBoxSearch";
import { UpdateFormDataStatusRowTool } from "./UpdateFormDataStatusRowTool";
import { ToolBoxCommonActions } from "../../Common/DataTableToolBox/ToolBoxCommonActions";

import { TRANSLATION_KEY } from '../../../constants/commonConstants';
import { DATA_TABLE_ROW_SELECTION_CHANGED } from "../../../constants/pubSubKeys";


interface IFormDataToolBoxProps {
    dataTableColumns: IDataTableColumn[];
}

export const FormDataToolBox: React.FC<IFormDataToolBoxProps> = ({ dataTableColumns }) => {

    const { t } = useTranslation([TRANSLATION_KEY.toString()]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);


    useEffect(() => {
        let rowSelectionPubSub = PubSub.subscribe(DATA_TABLE_ROW_SELECTION_CHANGED, (msg: string, selectedRowKeys: number[]) => {
            setSelectedRowKeys(selectedRowKeys);
        });
        return () => {
            PubSub.unsubscribe(rowSelectionPubSub);
        }
    }, []);


    return (
        <Card title={t('externalCommunication-formData-tableName')}>
            <p>{t('externalCommunication-formData-tableDescription')}</p>

            {
                selectedRowKeys.length > 0 &&
                <p>{t('dataTable-selected')} <strong>{selectedRowKeys.length}</strong> {t('dataTable-items')}</p>
            }

            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <ToolBoxSearch dataTableColumns={dataTableColumns} />
                </Col>
                <Col span={24}>
                    <ToolBoxCommonActions isShowCopy={false} isShowCreateNew={false} isShowImport={false} isShowColumnSelector={false}/>

                    <UpdateFormDataStatusRowTool className="mt-13-px" selectedRowKeys={selectedRowKeys}/>
                </Col>
            </Row>

            {/* <ToolBoxColumnSelector dataTableColumns={dataTableColumns} settingsKey={SETTINGS_DATA_TABLE_VISIBLE_COLUMNS_FORM_DATA_KEY} /> */}

        </Card>
    );

}

